import React from "react";
// reactstrap components
import {
  FormGroup,
  Row,
  Col,
  Button
} from "reactstrap";
import Select from "react-select";

class Step1 extends React.Component {
  
  render() {

    const {
      reportType,
      setReportType
    } = this.props;

    return (
      <>
        <h5 className="info-text">
          Let's start with the basic information
        </h5>
        <Row className="justify-content-center mt-5">
          <Col sm="10">
            <FormGroup>
              <label>Report type</label>
              <Select
                className="react-select info"
                classNamePrefix="react-select"
                name=""
                onChange={value => {
                    setReportType(value);
                  }
                }
                value={reportType}
                options={[
                  { value: "zeroVatClients", label: "Zero-VAT clients" },
                  { value: "unitCost", label: "Unit Cost" },
                ]}
                placeholder="Select the report type"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="d-flex justify-content-lg-around mt-3">
            <Button 
                onClick={this.props.previousStep}
                disabled={!this.props.previousStep}
            >
                Previous Step
            </Button>
            <Button 
                onClick={this.props.nextStep}
                disabled={!this.props.nextStep}
            >
                Next Step
            </Button>
        </Row>
      </>
    );
  }
}

export default Step1;
